// extracted by mini-css-extract-plugin
export default {"topPanel":"TopPanel_topPanel__t-xO9","currentPage":"TopPanel_currentPage__KcPGP"};